import { createApp, toRaw } from "vue"
import HorizontalLinks from "../components/HorizontalLinks.vue"
import ActionSheet from "../components/ActionSheet.vue"
import SelectSearchable from "../components/SelectSearchable.vue"
import ClickOutside from "../directives/ClickOutside"
import { Locations } from "../services/locations"
import ShowCompaniesWrapper from "../components/Companies/ShowCompaniesWrapper.vue"
import BudgetModal from "../components/BudgetModal"
import VueMask from '@devindex/vue-mask'

import { Swiper, SwiperSlide } from "swiper/vue"
import { Scrollbar, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

const locations = new Locations()

const app = createApp({
    components: {
        ActionSheet,
        HorizontalLinks,
        SelectSearchable,
        ShowCompaniesWrapper,
        Swiper,
        SwiperSlide,
        BudgetModal,
    },
    data() {
        return {
            showFilters: false,
            budget: false,
            form: {
                cidade: window.parameters.cidade || "",
                bairro: window.parameters.bairro || "",
                facilidades: [],
                funcionamento: [],
                uf: window.locations?.current || "rn",
                ...(window.query || {}),
            },
            cidades: [],
            bairros: [],
            featuredBreakpoints: {
                0: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 2,
                },
            },
            featuredCompaniesBreakpoints: {
                0: {
                    slidesPerView: 1,
                    enabled: false,
                },
                768: {
                    enabled: true,
                    slidesPerView: 1,
                },
                900: {
                    slidesPerView: 2,
                },
            },
            Pagination,
            Scrollbar,
        }
    },
    methods: {
        loadCidades() {
            this.cidades = [
                {
                    slug: "",
                    nome: "Cidade",
                },
            ]
            locations.cidades({ uf: this.form.uf }).then((response) => {
                this.cidades.push(...response.data)
            })
        },
        loadBairros() {
            this.bairros = [
                {
                    slug: "",
                    nome: "Bairro",
                },
            ]
            if (!this.form.cidade) return
            locations.bairros({ cidade: this.form.cidade }).then((response) => {
                this.bairros.push(...response.data)
            })
        },
    },
    created() {
        this.loadCidades()
        this.loadBairros()
    },
    computed: {
        countFilters() {
            let form = toRaw(this.form)

            return (
                Object.values(form).filter((i) =>
                    Array.isArray(i) ? i.length : !!i
                ).length + form.facilidades.length ||
                0 + form.funcionamentos.length ||
                0
            )
        },
        getFilterUrl() {
            return [
                window.routes["current"].replace("__uf", this.form.uf),
                this.form.cidade || null,
                this.form.cidade && this.form.bairro ? this.form.bairro : null,
            ]
                .filter(Boolean)
                .join("/")
        },
    },
    watch: {
        "form.cidade": {
            deep: true,
            handler() {
                this.loadBairros()
            },
        },
        "form.uf": {
            deep: true,
            handler() {
                this.loadCidades()
            },
        },
    },
})
app.directive("click-outside", ClickOutside)
app.use(VueMask)
app.mount("#offers-container")
